import React, { PropsWithChildren } from 'react';
import { Pill } from './Pill';

export type CircleProps = {
  color?: string;
  size?: number;
  style?: React.CSSProperties;
  className?: string;
};

export const Circle: React.FC<PropsWithChildren<CircleProps>> = ({
  style,
  className,
  size = 12,
  color,
  children = null,
}) => (
  <Pill
    width={size}
    height={size}
    color={color}
    style={style}
    className={className}
  >
    {children}
  </Pill>
);
